const helper = {
    cleanMachineName: (machine_name, section_machine_name) => {
        return machine_name.replace(`_${section_machine_name}_`, '')
    },
    modifyMachineName: (machine_name, section_machine_name) => {
        return `_${section_machine_name}_${machine_name}`
    },
    scrollToTop: () => {
        const form = document.getElementById("simple-modal")
        form && form.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
        })
    }
}

export default helper;